import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

export interface ToastMessageData {
	message: string;
	isError: boolean;
}

@Component({
	selector: 'app-toast-message',
	template: `
		<div class="app-toast-content">
			<mat-icon class="app-toast-icon">{{
				data && data.isError ? 'error_outline' : 'check_circle_outline'
			}}</mat-icon>
			<span class="app-toast-text">{{ data && data.message ? data.message : '' }}</span>
		</div>
	`,
})
export class ToastMessageComponent {
	constructor(@Inject(MAT_SNACK_BAR_DATA) public data: ToastMessageData) {}
}
